module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('demonstration', {
    attrs: {
      "tag": "h2",
      "title": "Input 输入框",
      "description": "通过鼠标或键盘输入字符",
      "show-content": false
    }
  }), _vm._v(" "), _c('demonstration', {
    attrs: {
      "title": "基础用法",
      "anchor": "demo-code-title",
      "highlight": _vm.sourcecode1
    }
  }, [_c('template', {
    slot: "description"
  }, [_vm._v("\n            简单描述一下示例代码标题\n        ")]), _vm._v(" "), _c('template', {
    slot: "source"
  }, [_c('div', {
    staticClass: "source"
  }, [_c('vm-input', {
    attrs: {
      "placeholder": "请输入内容",
      "maxlength": 10
    },
    model: {
      value: (_vm.input),
      callback: function($$v) {
        _vm.input = $$v
      },
      expression: "input"
    }
  })], 1)]), _vm._v(" "), _c('template', {
    slot: "explanation"
  }, [_vm._v("\n            对你的代码进行描述\n        ")])], 2), _vm._v(" "), _c('demonstration', {
    attrs: {
      "title": "禁用状态",
      "anchor": "demo-code-title",
      "highlight": _vm.sourcecode2
    }
  }, [_c('template', {
    slot: "description"
  }), _vm._v(" "), _c('template', {
    slot: "source"
  }, [_c('div', {
    staticClass: "source"
  }, [_c('vm-input', {
    attrs: {
      "placeholder": "请输入内容",
      "disabled": true
    },
    model: {
      value: (_vm.input1),
      callback: function($$v) {
        _vm.input1 = $$v
      },
      expression: "input1"
    }
  })], 1)]), _vm._v(" "), _c('template', {
    slot: "explanation"
  }, [_vm._v("\n            通过 disabled 属性指定是否禁用 input 组件\n        ")])], 2), _vm._v(" "), _c('demonstration', {
    attrs: {
      "title": "带 icon 的输入框",
      "anchor": "demo-code-title",
      "highlight": _vm.sourcecode5
    }
  }, [_c('template', {
    slot: "description"
  }, [_vm._v("\n            带有图标标记输入类型\n        ")]), _vm._v(" "), _c('template', {
    slot: "source"
  }, [_c('div', {
    staticClass: "source"
  }, [_c('vm-input', {
    attrs: {
      "placeholder": "请输入内容",
      "icon": "vm-input-icon-search",
      "onIconClick": _vm.handleIconClick
    },
    model: {
      value: (_vm.input2),
      callback: function($$v) {
        _vm.input2 = $$v
      },
      expression: "input2"
    }
  })], 1)]), _vm._v(" "), _c('template', {
    slot: "explanation"
  }, [_vm._v("\n            可以通过 icon 属性在 input 组件尾部增加显示图标，字体图标需要自己引入，可以通过 on-icon-click 钩子函数来在点击图标后执行需要的逻辑。\n        ")])], 2), _vm._v(" "), _c('demonstration', {
    attrs: {
      "title": "文本域",
      "anchor": "demo-code-title",
      "highlight": _vm.sourcecode3
    }
  }, [_c('template', {
    slot: "description"
  }, [_vm._v("\n            用于输入多行文本信息，通过将 type 属性的值指定为 textarea。\n        ")]), _vm._v(" "), _c('template', {
    slot: "source"
  }, [_c('div', {
    staticClass: "source"
  }, [_c('div', {
    staticClass: "textareaBox"
  }, [_c('vm-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请输入内容",
      "rows": 3
    },
    model: {
      value: (_vm.textarea),
      callback: function($$v) {
        _vm.textarea = $$v
      },
      expression: "textarea"
    }
  })], 1)])]), _vm._v(" "), _c('template', {
    slot: "explanation"
  }, [_vm._v("\n            文本域高度可通过 rows 属性控制\n        ")])], 2), _vm._v(" "), _c('demonstration', {
    attrs: {
      "title": "可自适应文本高度的文本域",
      "anchor": "demo-code-title",
      "highlight": _vm.sourcecode4
    }
  }, [_c('template', {
    slot: "description"
  }, [_vm._v("\n            通过设置 autosize 属性可以使得文本域的高度能够根据文本内容自动进行调整，并且 autosize 还可以设定为一个对象，指定最小行数和最大行数。\n        ")]), _vm._v(" "), _c('template', {
    slot: "source"
  }, [_c('div', {
    staticClass: "source"
  }, [_c('div', {
    staticClass: "textareaBox"
  }, [_c('vm-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请输入内容",
      "autosize": ""
    },
    model: {
      value: (_vm.textarea2),
      callback: function($$v) {
        _vm.textarea2 = $$v
      },
      expression: "textarea2"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "20px 0"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "textareaBox"
  }, [_c('vm-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请输入内容",
      "autosize": {
        minRows: 2,
        maxRows: 4
      }
    },
    model: {
      value: (_vm.textarea3),
      callback: function($$v) {
        _vm.textarea3 = $$v
      },
      expression: "textarea3"
    }
  })], 1)])]), _vm._v(" "), _c('template', {
    slot: "explanation"
  }, [_vm._v("\n            对你的代码进行描述\n        ")])], 2), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-demo__item"
  }, [_c('h3', {
    attrs: {
      "id": "attributes"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "./#attributes",
      "aria-hidden": "true"
    }
  }, [_vm._v("¶")]), _vm._v("\n            Input Attributes\n        ")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("可选值")]), _vm._v(" "), _c('th', [_vm._v("默认值")])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("type")]), _vm._v(" "), _c('td', [_vm._v("类型")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_vm._v("text/textarea")]), _vm._v(" "), _c('td', [_vm._v("text")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("value")]), _vm._v(" "), _c('td', [_vm._v("绑定值")]), _vm._v(" "), _c('td', [_vm._v("string, number")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("maxlength")]), _vm._v(" "), _c('td', [_vm._v("最大输入长度")]), _vm._v(" "), _c('td', [_vm._v("number")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("minlength")]), _vm._v(" "), _c('td', [_vm._v("最小输入长度")]), _vm._v(" "), _c('td', [_vm._v("number")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("placeholder")]), _vm._v(" "), _c('td', [_vm._v("输入框占位文本")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("disabled")]), _vm._v(" "), _c('td', [_vm._v("禁用")]), _vm._v(" "), _c('td', [_vm._v("boolean")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("false")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("icon")]), _vm._v(" "), _c('td', [_vm._v("输入框尾部图标")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("rows")]), _vm._v(" "), _c('td', [_vm._v("输入框行数，只对 type=\"textarea\" 有效")]), _vm._v(" "), _c('td', [_vm._v("number")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("2")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("autosize")]), _vm._v(" "), _c('td', [_vm._v("自适应内容高度，只对 type=\"textarea\" 有效，可传入对象，如，{ minRows: 2, maxRows: 6 }")]), _vm._v(" "), _c('td', [_vm._v("boolean/object")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("false")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("autowidth")]), _vm._v(" "), _c('td', [_vm._v("宽度是否是100%")]), _vm._v(" "), _c('td', [_vm._v("boolean")]), _vm._v(" "), _c('td', [_vm._v("true, false")]), _vm._v(" "), _c('td', [_vm._v("false")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("auto-complete")]), _vm._v(" "), _c('td', [_vm._v("原生属性，自动补全")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_vm._v("on, off")]), _vm._v(" "), _c('td', [_vm._v("off")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("name")]), _vm._v(" "), _c('td', [_vm._v("原生属性")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("readonly")]), _vm._v(" "), _c('td', [_vm._v("原生属性，是否只读")]), _vm._v(" "), _c('td', [_vm._v("boolean")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("false")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("max")]), _vm._v(" "), _c('td', [_vm._v("原生属性，设置最大值")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("min")]), _vm._v(" "), _c('td', [_vm._v("原生属性，设置最小值")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("step")]), _vm._v(" "), _c('td', [_vm._v("原生属性，设置输入字段的合法数字间隔")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("autofocus")]), _vm._v(" "), _c('td', [_vm._v("原生属性，自动获取焦点")]), _vm._v(" "), _c('td', [_vm._v("boolean")]), _vm._v(" "), _c('td', [_vm._v("true, false")]), _vm._v(" "), _c('td', [_vm._v("false")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("form")]), _vm._v(" "), _c('td', [_vm._v("原生属性")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("inputclass")]), _vm._v(" "), _c('td', [_vm._v("input 类名,宽度100%需要autowidth属性配置，")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("on-icon-click")]), _vm._v(" "), _c('td', [_vm._v("点击 Input 内的图标的钩子函数")]), _vm._v(" "), _c('td', [_vm._v("function")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("—")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-demo__item"
  }, [_c('h3', {
    attrs: {
      "id": "event"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "./#event",
      "aria-hidden": "true"
    }
  }, [_vm._v("¶")]), _vm._v("\n            Input Events\n        ")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('th', [_vm._v("事件名称")]), _vm._v(" "), _c('th', [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("回调参数")])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("blur")]), _vm._v(" "), _c('td', [_vm._v("在 Input 失去焦点时触发")]), _vm._v(" "), _c('td', [_vm._v("(event: Event)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("focus")]), _vm._v(" "), _c('td', [_vm._v("在 Input 获得焦点时触发")]), _vm._v(" "), _c('td', [_vm._v("(event: Event)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("change")]), _vm._v(" "), _c('td', [_vm._v("在 Input 值改变时触发")]), _vm._v(" "), _c('td', [_vm._v("(value: string | number)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("enter")]), _vm._v(" "), _c('td', [_vm._v("当 Input 获得焦点时，按enter键时触发")]), _vm._v(" "), _c('td', [_vm._v("(event: Event)")])])])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4868e0ce", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4868e0ce","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./example/src/App.vue
// module id = 21
// module chunks = 0